import React from 'react'

const Lauaayotajakhabar = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. दिइएका अर्थ दिने शब्द पाठबाट खोजेर लेख्नुहोस् :</h5>
        <p>(क) पत्रपत्रिका = अखवार</p>
        <p>(ख) मञ्चको छेउछाउको भाग = नेपथ्य</p>
        <p>(ग) रमित = तमासा</p>
        <p>(घ) विपत् = आपत्</p>
        <p>(ङ) एम्बुलेन्सले बजाउने आवाज = साइरन</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका पदावली र अर्थको जोडा मिलाउनुहोस :</h5>
        <p>(क) मधुरो प्रकाश - अलि अलि उज्यालो</p>
        <p>(ख) बस बिसौनी - बस चढ्न र ओर्लन रोकिने ठाउँ</p>
        <p>(ग) ताजा खबर - नयाँ समाचार</p>
        <p>(घ) निन्दनीय कार्य - निन्दा गर्नुपर्ने काम</p>
        <p>(ङ) जीवनको अध्याय - जिन्दगीको कालखण्ड</p>
        <p>(च) प्रस्थान गर्नु - बाहिर जानु</p>
        <p>(छ) भविष्यको लठ्ठी - भोलिको सहारा</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका शब्दहरुको विपरीत अर्थ दिने शब्द पाठबाट खोजेर लेख्नुहोस् :</h5>
        <p>बासी = ताजा</p>
        <p>चहकिलो = मधुरो</p>
        <p>दोष = निर्दोष</p>
        <p>पराई = आफन्त</p>
        <p>भाग्यमानी = अभागी</p>
        <p>बन्धन = मुक्ति</p>
        <p>अदृश्य = दृश्य</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका आशय झल्कने उखान लघुनाटकबाट खोजेर लेख्नुहोस् :</h5>
        <h5>(क) इच्छाशक्ति भए जुनसुकै काम गर्न सकिन्छ</h5>
        <p>खाने मुखलाई जुँगाले छेक्दैन ।</p>
        <h5>(ख) अरुलाई पर्ने समस्या तपाईंलाई पनि पर्छ</h5>
        <p>अरुलाई खाने बाघले तपाईंलाई पनि खान्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. तपाईंले सुनेका / पढेका पाँचओटा उखान लेखी वाक्यमा प्रयोग गर्नुहोस् :</h5>
        <h5>(क) नाच्न जान्दैन आँगन टेढो :</h5>
        <p>= रामले आफ्नो गल्ती स्विकार्नुभन्दा सधैं अरूलाई दोष दिने गर्छ, नाच्न जान्दैन आँगन टेढो भनेजस्तै ।</p>
        <h5>(ख) अचानोको पीर खुकुरीले बुझ्दैन :</h5>
        <p>गरिबको दुःख धनीले बुझ्न सक्दैन, यो त अचानोको पीर खुकुरीले बुझ्दैन भनेजस्तै हो ।</p>
        <h5>(ग) जुन जोगी आए पनि कानै चिरेका :</h5>
        <p>सरकार फेरिए पनि भ्रष्टाचार रोकिएको छैन, जुन जोगी आए पनि कानै चिरेका भनेजस्तै ।</p>
        <h5>(घ) आफू नमरी स्वर्ग देखिदैन :</h5>
        <p>जुनसुकै सफलताको लागि पनि कडा मिहिनेत गर्नुपर्छ, आखिर आफू नमरी स्वर्ग देखिदैन ।</p>
        <h5>(ङ) नपत्याउने खोलाले बगाउँछ :</h5>
        <p>सानो देखिएको समस्या ठूलो बन्न सक्छ, नपत्याउने खोलाले बगाउँछ भनेजस्तै सजग रहनु पर्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. दिइएका टुक्काहरुलाई वाक्यमा प्रयोग गर्नुहोस् :</h5>
        <strong>खरानी हुनु</strong>
        <p>उसको सपना पूरा नहुँदै खरानी भयो, सबै मिहिनेत बर्बाद भयो।</p>
        <strong>पेट पाल्नु</strong>
        <p>नेपालमा पेट पाल्न गाह्रो भएर विदेश पलायन हुने क्रम बढ्दो छ।</p>
        <strong>कुरा खानु</strong>
        <p>दाइको सुझाव नमान्दा पछि धेरै दुःख भोग्नु पर्‍यो, अबचाहिँ कुरा खान सिकेँ।</p>
        <strong>टाउको खानु</strong>
        <p>सानो भाइले दिनभर एउटै कुरा गरेर मेरो टाउको खायो।</p>
        <strong>कुरा दोचार्नु</strong>
        <p>उसले गरेको कुरा सबैले दोचारेर गाउँभर फैलाइदिए।</p>

        <strong>आलु खानु</strong>
        <p>पढेको भए पास हुनेथियो, अब फेरि उसले आलु खानु पर्‍यो।</p>

        <strong>सपना चकनाचुर हुनु</strong>
        <p>दुर्घटनापछि उसको खेलाडी बन्ने सपना चकनाचुर भयो।</p>

        <strong>सपना पूरा हुनु</strong>
        <p>आफ्नै घर किन्न सक्दा उसले धेरै समयदेखिको सपना पूरा गर्‍यो।</p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. छोटो उत्तर दिनुहोस् :</h5>
        <h5>(क) यस लघुनाटकमा कस्तो विषयलाई प्रस्तुत गरिएको छ ?</h5>
        <p>= यस लघुनाटकमा दुर्व्यसनीको विषयवस्तुलाई प्रस्तुत गरिएको छ ।</p>
        <h5>(ख) यस लघुनाटकमा कति जना मञ्चीय पात्रहरु छन् ?</h5>
        <p>= यस लघुनाटकमा ८ जना मञ्चीय पात्रहरु छन् ।</p>
        <h5>(ग) यस लघुनाटकको पात्रका संवादमा कुन कुन भाषाको प्रभावदेख्न सकिन्छ ?</h5>
        <p>= यस लघुनाटकमा शेर्पा, नेवारी र हिन्दी भाषाको प्रभाव देख्न सकिन्छ ।</p>
        <h5>(घ) यस लघुनाटकमा कुन परिवेशलाई समेटिएको छ ?</h5>
        <p>= यस लघुनाटकमा सहरिया परिवेशलाई समेटिएको छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>२. सबैभन्दा मिल्दो उत्तरमा रेजा (ठीक) लगाउनुहोस् :</h5>
        <p>(क) सामाजिक</p>
        <p>(ख) सहरिया</p>
        <p>(ग) बहुभाषिक समाज</p>
        <p>(घ) दाह्री बाबा</p>
        <p>(ङ) एक</p>
        <p>(च) पत्रिका बेच्ने केटा</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएको संवाद कसले भनेको हो, वक्ता पहिल्याउनु होस् :</h5>
        <p>(क) दाह्री बाबा</p>
        <p>(ख) नरहरि</p>
        <p>(ग) दीनदयाल</p>
        <p>(घ) दोर्जे</p>
        <p>(ङ) तुयुमै</p>
        <p>(च) कुमारका बुबा</p>
        <p>(छ) सलिम</p>
        <p>(ज) कुमारका बुबा</p>
        <p>(झ) दोर्जे</p>
        <p>(ञ) पत्रिका बेच्ने केटो</p>
      </div>
      <hr/>
      <div>
        <h5>४. "पर्खनुस् ! जानुभन्दा ……..मिलेर गरौँ "नाट्यांश पढी सोधिएका प्रश्नको उत्तर दिनुहोस् :</h5>
        <h5>(क) `देश नबने हामी कोही बन्दैनौ´ भन्ने वाक्यको तात्पर्य खुलाउनुहोस् ।</h5>
        <p>= देशको प्रगति, सम्रिधि र विकाश नभएसम्म हामीले सुख र खुसि पाउदैनौ भन्नु नै देश नबने हामी कोही बन्दैनौ भन्नुको तात्पर्य हो ।</p>
        <h5>(ख) खुसी भएर बाँच्न के गर्नुपर्छ ?</h5>
        <p>= खुसी भएर बाँच्नका लागि एकाअर्काको सुख दुःखमा मिलेर, साथ दिएर बाँच्नुपर्छ ।</p>
        <h5>(ग) सामूहिक अभियान किन चलाइएको हो ?</h5>
        <p>= सामूहिक अभियान दुर्व्यसनको जडलाई उखेली समाजबाट बिकृति विसंगति हटाउनका लागि चलाइएको हो ।</p>
        <h5>(घ) कस्तो अभिभावकलाई कर्तव्यनिष्ठ अभिभावक भनिन्छ ?</h5>
        <p>= आफ्नो सन्तान प्रति आफ्नो जिम्मेवारी पूरा गर्ने अभिभावकलाई कर्तव्यनिष्ठ अभिभावक भनिन्छ ।</p>
      </div>
      <hr/>
      <div>
       <h5>५. दिइएको नाट्यांश पढी सोधिएका प्रश्नहरुको छोटो उत्तर दिनुहोस् :</h5>
       <h5>(अ) लघुनाटकमा आफन्तको आगमन भइरहनुको कारण के हो ?</h5>
       <p>= दुई दिनदेखि बेखबर भई घर नफर्केको आफ्नो छोरा नै कतै समाचारपत्रमा छापिएअनुसारको बेवारिसे अवस्थामा भेटिएको एउटा युवकको लास आफ्नै छोराको होला भनेर आफन्तको आगमन भइरहेको हो ।</p>

       <h5>(आ) मरेको वा नजन्मेको मान्छे राम्रो हुन्छ भन्ने भनाइसँग तपाईको सहमति वा असहमतिका बुँदाहरु लेख्नुहोस् ।</h5>
       <p>= मरेको वा नजन्मेको मान्छे राम्रो हुन्छ भन्ने भनाइप्रति म असमत छु । किनकि :
        </p><p>
1. मरेको वा नजन्मेको मान्छेको कुनै मोल नै नभएकाले,
</p><p>
2. धर्तिमा भौतिक उपस्तिति नभई उसको गुड पत्ता लगाउन नसकिने भएकाले,
तेसैले मरेको वा नजन्मेको मान्छे न त राम्रो हुन्छ न त नराम्रो नै ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. दिइएको नाट्यांश पढी सोधिएका प्रश्नहरुको छोटो उत्तर दिनुहोस् :</h5>
        <h5>(अ) यस नाट्यांशमा वक्ताले आफ्ना के कस्ता कमजोरी रहेको स्विकारेका छन् ?</h5>
        <p>= यस नाट्यांशमा वक्ताले आफ्ना सन्तानप्रति आफ्नो कर्तव्य एवं जिम्मेवारी बोध नगर्नुका साथै रेखदेख एवं निगरानी नगरेकै कारण लागुपदार्थ दुर्व्यसनीको सिकार बन्न गएको वास्तविकतालाई स्विकारेका छन् । वक्ताले आफ्नो छोरासँगै बसी उसको पढाइको बारेमा कुरा नगरेको, छोराको साथीसङ्गतको बारेमा सोधखोज नगरेको, कहाँ के गर्छ भनी ख्याल नगरेको, छोराले मागेजति पैसा दिएपनि के कसरी खर्च गरेको छ भनी विचार नगरि केबल ब्यवसाय र बैठक भनी दौडधूप गरेको कुरा स्विकारेका छन् ।</p>
        <h5>(आ) यस नाट्यांशमा व्यक्त समस्या कसरी समाधान गर्न सकिएला ?</h5>
        <p>= यस नाट्यांशमा वक्ताले आफ्ना सन्तानप्रति आफ्नो कर्तव्य एवं जिम्मेवारी बोध नगर्नुका साथै रेखदेख एवं निगरानी नगरेकै कारण लागुपदार्थ दुर्व्यसनीको सिकार बन्न गएको समस्या व्यक्त गरेका छन् । आफ्नो सन्तानसँगै बसी उसको पढाइको बारेमा कुरा गर्ने, उनीहरुको साथीसङ्गतको बारेमा सोधखोज गर्ने, कहाँ के गर्छन् भनी ख्याल गर्ने, मागेजति पैसा दिएपनि के कसरी खर्च गरेको छ भनि विचार गर्ने र उनीहरुलाई माया र ममता दिएर रेखदेख गरेर मात्र नाट्यांशमा व्यक्त समस्या समाधान गर्न सकिएला ।</p>
      </div>
      <hr/>
      <div>
        <h5>७. व्याख्या गर्नुहोस् :</h5>
        <h5>(क) दुर्व्यसनको जडलाई उखेल्ने काम एउटा व्यक्तिले मात्र सक्दैन ।</h5>
        <p>= ‘लौ आयो ताजा खबर’ कक्षा ११ को नेपाली पाठ्यक्रममा समावेश गरिएको लघु नाटक हो, जसका लेखक सुरेन्द्र नकर्मी हुन्। उनी नेपाली साहित्यका प्रगतिशील लेखक मानिन्छन्। सामाजिक यथार्थलाई सरल र प्रभावशाली शैलीमा प्रस्तुत गर्न उनी ख्यातिप्राप्त छन्। यस नाटकमा उनले समाजमा बढ्दो दुर्व्यसनजस्तो गम्भीर समस्यालाई उठान गरी जनचेतनामूलक सन्देश दिएका छन्।</p>
        <p>नाटकमा दुर्व्यसन एक गम्भीर सामाजिक समस्या हो भन्ने सन्देश दिइएको छ। दुर्व्यसनले व्यक्ति, परिवार, समाज र राष्ट्रलाई प्रत्यक्ष रूपमा असर पुर्‍याउँछ। यसले मानिसको मस्तिष्क र स्नायुतन्त्रलाई क्षति पुर्‍याई सोच्ने र बुझ्ने क्षमतामा असर गर्छ। विशेष गरी युवावर्ग दुर्व्यसनको मुख्य शिकार बन्ने भएकाले उनीहरूलाई समयमै सचेत तुल्याउन जरुरी छ। यसका लागि अभिभावकले आफ्ना सन्तानको गतिविधि, साथीहरू र खर्चबारे चासो राख्नुपर्छ। यदि दुर्व्यसनको संकेत देखिएमा उचित सल्लाह, सहयोग र उपचार आवश्यक हुन्छ। नाटकले परिवार, समाज र राष्ट्र सबै मिलेर मात्रै यसको समाधान सम्भव छ भन्ने स्पष्ट सन्देश दिन्छ।</p>
        <p>दुर्व्यसनजस्तो गम्भीर समस्याको अन्त्य एक व्यक्तिले मात्र गर्न सक्दैन। यसको जड उखेल्न समाजका सबै तहबाट सामूहिक प्रयास आवश्यक पर्छ। परिवार, समुदाय, प्रशासन र राज्य संयन्त्र एकजुट भई कानुनी तथा सामाजिक रूपमा अगाडि बढेमा मात्रै दुर्व्यसनमुक्त समाजको निर्माण सम्भव छ। यस नाटकले युवालाई दुर्व्यसनबाट जोगाउन सबैले आ-आफ्नो भूमिका निर्वाह गर्नुपर्छ भन्ने चेतना दिन सफल भएको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>(ख) जब तिमी हाम्रो देशमा……….स्वच्छ हुन्छ ।</h5>
        <p>= ‘लौ आयो ताजा खबर’ कक्षा ११ को नेपाली विषयअन्तर्गत समावेश गरिएको लघु नाटक हो, जसका लेखक सुरेन्द्र नकर्मी हुन्। उनले पत्रकारिताको मर्म, धर्म र सामाजिक दायित्वलाई व्यङ्ग्यात्मक शैलीमा प्रस्तुत गरेका छन्। यस नाटकमार्फत युवालाई दुर्व्यसनबाट जोगाउँदै राष्ट्र निर्माणमा लगाउन पत्रपत्रिकाले कसरी सकारात्मक भूमिका खेल्न सक्छन् भन्ने सन्देश प्रभावकारी रूपमा दिइएको छ।</p>
        <p>नाटकमा देशका युवापुस्तालाई दुर्व्यसनबाट टाढा राखी जागरूक, शिक्षित र उर्जाशील बनाउनु राष्ट्रको दायित्व हो भन्ने कुरा उठाइएको छ। युवाहरु देशका कर्णधार हुन्। उनीहरूलाई सही मार्गदर्शन दिन पत्रपत्रिकाहरूको भूमिका महत्त्वपूर्ण हुन्छ। तर, आजभोलि बासी, निराशाजनक र मूल्यहीन समाचारहरू बढी प्रकाशित भइरहेका छन्। नाटकले चाहिँ यस्तो पत्रकारिताको आलोचना गर्दै युवाको ऊर्जा र राष्ट्र निर्माणमा लगनशीलता झल्किने सकारात्मक खबर लेख्न जोड दिएको छ। जब सञ्चार माध्यमहरूले युवालाई दुर्व्यसनबाट जोगाउने र उनीहरूको सकारात्मक प्रयासलाई उजागर गर्ने समाचार सम्प्रेषण गर्छन्, तब मात्र पत्रिका ताजा र स्वच्छ हुन्छ भन्ने सन्देश स्पष्ट हुन्छ।</p>
        <p>पत्रकारिता समाजको ऐना हो, र राज्यको चौथो अङ्गका रूपमा यसको जिम्मेवारी झन् ठूलो हुन्छ। समाजमा दुर्व्यसनजस्ता समस्याको समाधानका लागि सञ्चार माध्यमले चेतनाको संवाहक बन्नुपर्छ। सकारात्मक सोच, सामाजिक सचेतना अभियान, जनचेतनामूलक कार्यक्रमहरू र युवाको सफलताका कथा छापेर मात्र सञ्चार माध्यमले ताजा र स्वच्छ खबर दिन सक्छन्। जब देशका पत्रपत्रिकामा दुर्व्यसनमुक्त समाजको समाचार आउन थाल्छ, तब मात्रै हाम्रो देशको भविष्य उज्यालो हुन्छ भन्ने भाव यस अंशमा व्यक्त गरिएको छ। </p>
      </div>
      <hr/>
      <div>
        <h5>८. समीक्षात्मक उत्तर लेख्नुहोस् :</h5>
        <h5>(क) `लौ आयो ताजा खबर´ लघुनाटकको मुख्य पात्रको चरित्र चित्रण गर्नुहोस् ।</h5>
        <p>= ‘लौ आयो ताजा खबर’ लघुनाटकका मुख्य पात्र दारी बाबा हुन्। नाटकको सुरुदेखि अन्त्यसम्म देखा पर्ने उनी लेखकद्वारा सिर्जित प्रमुख पात्र हुन्। योगी रूपमा प्रस्तुत दारी बाबा सांसारिक मोहबाट मुक्त, चिन्तनशील, अनुभवी र समाजप्रति उत्तरदायी व्यक्तित्वका धनी देखिन्छन्। उनी आफ्नो कुटीमा बस्ने, गहिरो सोच र हास्ययुक्त बोलचाल गर्ने व्यक्ति हुन्।</p>
        <p>दारी बाबा बाहिरबाट हेर्दा सामान्य र केही हदसम्म ठट्टा–व्यङ्ग्य गर्ने, कहिले काहीँ बहुला जस्ता देखिने पात्र जस्तो लागे पनि वास्तवमा उनी समस्याको जरा समात्न सक्ने, सामाजिक चेतनाले भरिएको बौद्धिक व्यक्तित्व हुन्। उनी समाजमा बढ्दै गएको दुर्व्यसन, विशेष गरी युवाहरूमा यसको असरबारे गम्भीर रूपमा चिन्तित छन्। उनले नाटकभरि आफ्ना संवादहरूमार्फत यही सन्देश दिन खोजेका छन् कि, यदि आमाबाबाले सन्तानलाई समय नदिएर, उनीहरूको भावना नबुझी एकोहोरो व्यस्त जीवन बिताए भने उनीहरू दुर्व्यसनको शिकार बन्न सक्छन्।</p>
        <p>दारी बाबाले दुर्व्यसनको समस्या मात्र देखाउँदैनन्, यसको समाधान पनि सुझाउँछन्। उनी सबैलाई मिलेर काम गर्न प्रेरित गर्छन्। यस्तो सोच, चेतना र नेतृत्व क्षमता भएका पात्र भएकाले दारी बाबा यस नाटकका निश्चय नै केन्द्रबिन्दु हुन्। उनी नाटकको आत्मा हुन् जसले सम्पूर्ण सन्देशलाई प्रभावकारी ढंगले प्रस्तुत गरेका छन्।</p>
      </div>
      <hr/>
      <div>
        <h5>(ख) `लौ आयो ताजा खबर´लघुनाटकमा व्यक्त मुख्य सन्देशमाथि प्रकाश पार्नुहोस ।</h5>
        <p>= ‘लौ आयो ताजा खबर’ लघुनाटक सामाजिक यथार्थलाई उजागर गर्ने प्रगतिवादी नाटककार सुरेन्द्र नकर्मीद्वारा रचित सन्देशमूलक रचना हो। यो नाटक नेपाली समाजमा व्याप्त विकृति, विसङ्गति, दुर्व्यसन, भ्रष्ट राजनीति र मूल्यहीन पत्रकारितामाथि गम्भीर व्यङ्ग्य प्रहार गर्दै सकारात्मक परिवर्तनको पक्षमा आवाज उठाउँछ।</p>
        <p>नाटकमा दुर्व्यसनलाई प्रमुख समस्या मानेर प्रस्तुत गरिएको छ। यसले युवावर्गलाई त्यसबाट जोगाउन समाजको हरेक तह—व्यक्ति, परिवार, पत्रकारिता, प्रशासन र राजनीतिक दलहरू सबैको उत्तरदायित्व रहेको देखाइएको छ। विशेषतः अभिभावकले आफ्ना सन्तानप्रति ध्यान दिनु, समय दिनु, साथीसङ्गत र व्यवहारबारे चासो राख्नु आवश्यक छ भन्ने सन्देश छ।
          </p><p>
यसका अतिरिक्त, नाटकमा देखाइएको छ कि, पत्रपत्रिकाले सत्य, सकारात्मक र जनचेतनात्मक समाचार सम्प्रेषण गर्नुपर्छ। वर्तमान समयको झूट, सनसनी र मूल्यहीन पत्रकारिताले युवालाई झनै भ्रमित बनाउँछ। साथै, राजनीति पनि स्वार्थ, षड्यन्त्र र लोभले भरिएको छ, जसले समाजलाई अझ अन्धकारतिर डोर्याउँछ। त्यसैले यस्ता सबै विकृति र विसङ्गति उखेलेर स्वच्छ, न्यायपूर्ण र सभ्य समाज निर्माण गर्नुपर्ने सन्देश यस नाटकमा व्यक्त गरिएको छ।</p>
<p>समग्रमा, ‘लौ आयो ताजा खबर’ लघुनाटकले युवापुस्तालाई दुर्व्यसनबाट जोगाउन, पत्रकारितालाई मर्यादित बनाउन र समाजमा व्याप्त विकृतिलाई अन्त्य गरी सचेत, स्वच्छ र न्यायपूर्ण समाजको निर्माण गर्न सबै पक्षको सहभागिता आवश्यक छ भन्ने गम्भीर सन्देश दिन खोजेको छ। यो नाटक जागरण, परिवर्तन र उत्तरदायित्वको पक्षमा बलियो चेतना फैलाउने रचना हो।</p>
      </div>
      <hr/>
      <div>
        <h5>११. दिइएको अनुच्छेद पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) प्राणीशास्त्रले कुन विषयको अध्ययन गर्छ ?</h5>
        <p>= प्राणीशास्त्रले चिकित्सा विज्ञान, नर्सिङ विज्ञान ,आयुर्वेद विज्ञान आदि विषयको अध्ययन गर्दछ ।</p>
        <h5>(ख) जीवजन्तुको दोहनले प्रकृतिमा कस्तो असर पर्न सक्छ ?</h5>
        <p>= जीवजन्तुको दोहनले जैविक विविधतामा ह्रास आई पृथ्वी नै सङ्कटमा पर्ने सम्मको असर पर्न सक्छ ।</p>
        <h5>(ग) प्राणीशास्त्रको अध्ययनले हामीलाई कसरी प्रकृतिसँग नजिक बनाउँछ ?</h5>
        <p>= प्राणीशास्त्रको अध्ययनले हरेक प्राणी यस धर्तीका अभिन्न अङ्ग हुन् र हामीले प्रकृति र प्राणीहरूको सुरक्षा गर्नुपर्छ भन्ने ज्ञान दिई हामीलाई प्रकृतिसँग नजिक बनाउँछ ।</p>
        <h5>(घ) `दोहन´ र`पारस्पारिक´ शब्दको अर्थलेख्नुहोस् ।</h5>
        <p>= दोहन = लुट्ने वा शोषण गर्ने काम</p>
        <p>पारस्परिक = एक अर्कासंग सम्बन्धित</p>
      </div>
      <hr/>
      <div>
        <h3>व्याकरण</h3>
        <h5>१. दिइएको अनुच्छेदबाट प्रत्यय लागेका शब्द पहिचान गरी सूची बनाउनुहोस् :</h5>
        <p>केटा(केटो + आ)</p>
        <p>निन्दनीय (निन्द + अनीय)</p>
        <p>कार्य ( कृ + य)</p>
        <p>ढिस्का(ढिस्को + आ)</p>
        <p>लिएर ( लि + एर)</p>
        <p>पुग्ने( पुग् + ने)</p>
        <p>हजारौँ (हजार + औँ)</p>
        <p>जनता ( जन + ता)</p>
        <p>दैनिक( दिन + इक)</p>
        <p>गरी (गर् + ई)</p>
        <p>गर्दा ( गर् + दा)</p>
        <p>चलायमान (चलाउ + मान्)</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएको अनुच्छेदबाट प्रत्यय व्युत्पन्न शब्द पहिचान गरी निर्माण प्रक्रिया देखाउनुहोस् :</h5>
        <p>अपनत्व = आफ्नो + त्व</p>
        <p>भावना = भाव + ना</p>
        <p>होइन = हु + इन</p>
        <p>गरी = गर् + ई</p>
        <p>मिलेर = मिल् + एर</p>
        <p>पेटी = पेट + ई</p>
        <p>कर्तव्य = कृ + तव्य</p>
        <p>सामूहिक =समूह + इक</p>
        <p>नागरिक = नगर + इक</p>
        <p>गरौँ = गर् + औँ</p>
        <p>भावक = भु + अक</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका प्रत्यय लगाई एक एकओटा नयाँ शब्द निर्माण गर्नुहोस् :</h5>
        <strong>अक्कड</strong>
        <p>भुल् + अक्कड = भुलक्कड</p>
        <strong>अत</strong>
        <p>लिख् + अत = लिखत</p>
        <strong>अन्त</strong>
        <p>भिड् + अन्त = भिडन्त</p>
        <strong>अन</strong>
        <p>चर् + अन = चरन</p>
        <strong>अनी</strong>
        <p>ढाक् + अनी = ढकनी</p>
        <strong>आइँ</strong>
        <p>बस् + आइँ = बसाइँ</p>
        <strong>आइ</strong>
        <p>बस् + आइ = बसाइ</p>
        <strong>आउ</strong>
        <p>घाट + आउ = घटाउ</p>
        <strong>आलु</strong>
        <p>बढ् + आलु = बढालु</p>
        <strong>आव</strong>
        <p>चुन् + आव = चुनाव</p>
        <strong>आवट</strong>
        <p>बन् + आवट = बनावट</p>
        <strong>आहा</strong>
        <p>बस् + आहा = बसाहा</p>
        <strong>अन्ते</strong>
        <p>उड् + अन्ते = उडन्ते</p>
        <strong>आरु</strong>
        <p>सिक् + आरु = सिकारु</p>
        <strong>एको</strong>
        <p>उड् + एको = उडेको</p>
        <strong>एनी</strong>
        <p>आगो + एनी = अगेनी</p>
        <strong>उवा</strong>
        <p>सुत + उवा = सुतुवा</p>
        <strong>इलो</strong>
        <p>झार् + इलो = झरिलो</p>
        <strong>आ</strong>
        <p>छाप् + आ = छापा</p>
        <strong>दो</strong>
        <p>बढ् + दो = बढ्दो</p>
        <strong>नु</strong>
        <p>पढ् + नु = पढ्नु</p>
        <strong>एर</strong>
        <p>सिक् + एर = सिकेर</p>
        <strong>उन्जेल</strong>
        <p>जित् + उन्जेल = जितुन्जेल</p>
        <strong>ओट</strong>
        <p>छान् + ओट = छनोट</p>
        <strong>ओ</strong>
        <p>हाँस् + ओ = हाँसो</p>
        <strong>इयार</strong>
        <p>हात + इयार = हतियार</p>
        <strong>इलो</strong>
        <p>मल + इलो = मलिलो</p>
        <strong>ई</strong>
        <p>धन + ई = धनी</p>
        <strong>ए</strong>
        <p>धनकुटा + ए = धनकुटे</p>
        <strong>औली</strong>
        <p>पुर्खा + औली = पुर्ख्यौली</p>
        <strong>एली</strong>
        <p>पूर्व + एली = पूर्वेली</p>
        <strong>पना</strong>
        <p>तितो + पना = तितोपना</p>
        <strong>ली</strong>
        <p>झापा + ली = झापाली</p>
        <strong>ले</strong>
        <p>गाउँ + ले = गाउँले</p>
        <strong>आडी</strong>
        <p>गफ + आडी = गफाडी</p>
        <strong>अरी</strong>
        <p>राम्रो + अरी = राम्ररी</p>
        <strong>आइँ/याइँ</strong>
        <p>मूर्ख + आइँ = मुर्ख्याइँ</p>
        <strong>आइ</strong>
        <p>काम + आइ = कमाइ</p>
        <strong>आली</strong>
        <p>लेक + आली = लेकाली</p>
        <strong>आलु</strong>
        <p>माया + आलु = मायालु</p>
        <strong>आन</strong>
        <p>सिर् + आन = सिरान</p>
        <strong>इङ्गर</strong>
        <p>पात + इङ्गर = पतिङ्गर</p>
        <strong>इया</strong>
        <p>सहर + इया = सहरिया</p>
        <strong>औटे</strong>
        <p>कुरा + औटे = कुरौटे</p>
        
      </div>
    </div>
  )
}

export default Lauaayotajakhabar
